import { useFormContext } from "react-hook-form";
import { usePunditUserContext } from "@circle-react/contexts";
import { CustomizeLabels } from "./CustomizeLabels";
import { ReorderCourses } from "./ReorderCourses";
import { ReorderTopics } from "./ReorderTopics";

export const Options = () => {
  const { currentCommunitySettings } = usePunditUserContext();
  const isCourseCustomLabelsEnabled =
    currentCommunitySettings?.course_custom_labels_enabled;

  const { watch } = useFormContext();
  const topicsOrder = watch("topics_order");
  return (
    <div className="py-8 md:py-14">
      {topicsOrder.length > 0 && <ReorderTopics />}
      {isCourseCustomLabelsEnabled && <CustomizeLabels />}
      <ReorderCourses />
    </div>
  );
};
